export default "__VITE_ASSET__C6x9AusF__"